module.exports = __webpack_public_path__ + "static/media/chat_new.18311020.svg";